// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"133":"0c2b1ee3","161":"25500207","385":"1f3eb2f9","507":"6d9abb43","625":"db445c86","815":"fdd2a1c1","822":"2f6e596c","922":"81405608","961":"42c5dd57","977":"cb6704e0","980":"822559aa"}[chunkId] + ".chunk.js";
};